import levels from "#traditional-runtime-levels" with { type: "json" };

export function getLevels() {
  return levels;
}

export function getTraditionalLevels() {
  return levels;
}
